import type { EditorThemeClasses } from "lexical";

/**
 * Lexical theme for rich text markdown elements in AI Planner fields (SKE-2727)
 *
 * Design System Reference:
 * - Base text: 14px, 20px line-height, #333333 color, font-normal (400)
 * - Padding: 12px horizontal, 8px vertical
 * - Border: #e6e6e6 (default), #b9adff (focus)
 *
 * Styling Decisions:
 * - Bold: font-semibold (600) for subtle emphasis
 * - Lists: 12px left margin to match paragraph padding
 * - Quotes: #e6e6e6 border to match default border color
 * - Opacity transition: 200ms for balanced animation timing
 */
export const richTextTheme: EditorThemeClasses = {
  // Text formatting
  text: {
    bold: "font-semibold", // 600 weight - softer than font-bold
    italic: "italic",
    strikethrough: "line-through",
    underline: "underline",
  },

  // Lists
  list: {
    ul: "list-disc ml-[12px] my-[8px] text-[14px] leading-[20px] font-normal text-[#333333]", // Matches editor text styles
    ol: "list-decimal ml-[12px] my-[8px] text-[14px] leading-[20px] font-normal text-[#333333]", // Matches editor text styles
    listitem: "ml-[4px] text-[14px] leading-[20px] font-normal text-[#333333]", // Inherit base text styles
    nested: {
      listitem: "list-none", // Remove marker for nested items
    },
  },

  // Blockquotes
  quote: "border-l-4 border-[#e6e6e6] pl-[12px] my-[8px] text-[#666666] italic",

  // Paragraph - remove default margin for consistent spacing
  paragraph: "mb-0",
};
